<template>
  <basic-dialog v-model="dialog" :actionButtons="actionButtons" :loading="saving"
                :title="task.id ? $t('tasks_management.edit') : $t('tasks_management.create_task')">

    <v-card-text v-if="!loading" class="scroll-content">
      <v-form ref="form" class="mt-6">
        <v-select v-model="task.type" :dense="$vuetify.breakpoint.xsOnly"
                  :items="taskTypes"
                  :label="$t('tasks_management.task_type')"
                  :rules="[$rules.required]" class="mt-2 required"
                  clearable
                  item-text="text"
                  item-value="value" outlined>

        </v-select>
        <!--<v-autocomplete v-if="task.type === 'report'"
                        v-model="task.categoryId"
                        :dense="$vuetify.breakpoint.xsOnly"
                        :items="categories"
                        :label="$t('tasks_management.task_category')" :rules="[$rules.required]"
                        class="mt-2 required"
                        clearable
                        item-text="nameTextLabel"
                        item-value="id" outlined>
        </v-autocomplete>-->
        <category-select v-if="task.type === 'report'" v-model="task.categoryId"
                         :label="$t('tasks_management.task_category')"
                         :rules="[$rules.required]" class="mt-2 required"/>

        <translation-input :dense="$vuetify.breakpoint.xsOnly"
                           :label="$t('tasks_management.task_title')" :obj.sync="task"
                           class="mt-2"
                           field="nameTid"
                           outlined
                           prefix="f.staticTask.name"/>

        <translation-input :component-type="'v-textarea'"
                           :dense="$vuetify.breakpoint.xsOnly" :label="$t('tasks_management.task_description')"
                           :obj.sync="task"
                           class="mt-2"
                           field="descriptionTid"
                           outlined
                           prefix="f.staticTask.description"/>

        <v-select v-model="task.priority"
                  :dense="$vuetify.breakpoint.xsOnly"
                  :items="taskPriorities"
                  :label="$t('tasks_management.task_priority')"
                  class="mt-2"
                  outlined/>

        <v-select v-if="task.type === 'report'"
                  v-model="task.swotType"
                  :dense="$vuetify.breakpoint.xsOnly"
                  :hint="$t('tasks_management.task_swot_type_help')"
                  :items="swots"
                  :label="$t('tasks_management.task_swot_type')"
                  class="mt-2"
                  outlined
                  persistent-hint/>

        <v-autocomplete v-if="task.type === 'report'"
                        v-model="task.surveyQuestion"
                        :dense="$vuetify.breakpoint.xsOnly"
                        :hint="$t('tasks_management.task_question_help')"
                        :items="surveyQuestions"
                        :label="$t('tasks_management.task_question')" class="mt-2"
                        clearable
                        item-text="titleText"
                        item-value="id"
                        outlined
                        persistent-hint
                        return-object>
          <template v-slot:item="{item}">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.titleText }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t('teams.types.' + item.surveyType) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>

      </v-form>
    </v-card-text>

    <v-card-text v-else class="py-10">
      <hb-loading-indicator align-middle/>
    </v-card-text>

  </basic-dialog>
</template>

<script>
import BasicDialog from "@/components/BasicDialog";
import TranslationInput from "@/components/TranslationInput";
import surveyTemplateApi from "@/api/surveytemplate";
import staticTaskApi from "@/api/statictask";
import TranslationService from "@/service/translation.service";
import CategorySelect from "@/components/Category/CategorySelect";

export default {
  name: "EditTaskSettingsDialog",
  components: {CategorySelect, TranslationInput, BasicDialog},
  props: ['categories'],
  data() {
    return {
      loading: true,
      saving: false,
      dialog: false,
      task: {},
      taskTemplate: {
        id: null,
        categoryId: null,
        priority: null,
        swotType: null,
        surveyQuestion: null,
        name: '',
        description: '',
        type: 'report'
      },
      surveyTemplates: [],
      taskPriorities: [
        {value: 'LOW', text: this.$t('tasks.priorities.LOW')},
        {value: 'MEDIUM', text: this.$t('tasks.priorities.MEDIUM')},
        {value: 'HIGH', text: this.$t('tasks.priorities.HIGH')},
      ],
      swots: [
        {value: 'strength', text: this.$t('swot_types.strength')},
        {value: 'opportunity', text: this.$t('swot_types.opportunity')},
        {value: 'weakness', text: this.$t('swot_types.weakness')},
      ],
      actionButtons: {
        cancel: {
          click: this.close,
        },
        save: {
          click: this.save
        }
      }
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    async open(id) {
      this.loading = true;
      this.dialog = true;

      await this.getSurveyTemplates();

      if (id) {
        await this.reloadTask(id);
      } else {
        this.task = {...this.taskTemplate};
      }
      this.loading = false;
    },
    async reloadTask(id) {
      try {
        const response = await staticTaskApi.getStaticTask(id);
        if (response) {
          this.task = response;
        }
      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_loading_task'));
      }
    },
    async save() {
      if (!this.$refs.form) return;
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      try {
        await TranslationService.saveNewTranslations();
        if (this.task.id) {
          await staticTaskApi.updateStaticTask(this.task);
          this.$showSuccessNotification(this.$t('tasks_management.task_updated_succesfully'));
        } else {
          await staticTaskApi.createStaticTask(this.task);
          this.$showSuccessNotification(this.$t('tasks_management.task_created_succesfully'));
        }
        this.dialog = false;
      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_saving_task'));
        console.error(e);
      }
      this.$emit('refresh');
      this.saving = false;
    },
    async getSurveyTemplates() {
      try {
        const surveyTemplates = await surveyTemplateApi.getSurveyTemplates();
        if (surveyTemplates) {
          this.surveyTemplates = surveyTemplates.filter(st => st.active);
        }
      } catch (e) {
        this.$handleApiError(e, this.$t('errors.error_loading_surveytemplates'));
      }
    },

  },
  watch: {
    dialog(val) {
      if (!val && this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  computed: {
    taskTypes() {
      return [
        {value: 'report', text: this.$t('tasks.types.report')},
        {value: 'personnel_help', text: this.$t('tasks.types.personnel_help')},
        {value: 'management_help', text: this.$t('tasks.types.management_help')},
      ]
    },
    surveyQuestions() {
      let questions = [];
      this.surveyTemplates.forEach(st => {
        const stQuestions = st.questions.map(q => {
          q.surveyType = st.type
          return q;
        });
        questions = questions.concat(stQuestions);
      });
      return questions;
    }
  },
}
</script>

<style lang="scss" scoped>
.scroll-content {
  max-height: calc(100vh - 240px);
  overflow: auto;
}

@media screen and (min-width: 600px) {
  .scroll-content {
    max-height: calc(100vh - 300px);
    overflow: auto;
  }
}
</style>
